/* eslint-disable @typescript-eslint/naming-convention */
import React, { useState, useContext, useEffect } from 'react'
import LoaderFull from 'loader-full'
import { getPhoneCom } from 'phonecom'
import { ScreenSizeContext, WidgetArticleType, useWidgetContext } from 'providers'
import { getValue } from 'remote-config-value'
import { getFeatureEnabled } from 'feature-flag'
import { makeStyles } from '@material-ui/core/styles'
import { LoaderDialog } from 'functional-foundations'
import Tabs from './Tabs'
import Header from './Header'
import Enrollment from './Enrollment'
import BrandsContext from '../contexts/BrandsContext'
import { EnrollmentType } from '../interface/EnrollmentType'
import { CampaignContext } from '../contexts/CampaignContext'
import SmsEnrollmentInstruction from './SmsEnrollmentInstruction'
import { SmsNumberCampaignContext } from '../contexts/SmsNumberCampaignContext'

import {
    getAddBrandParams,
    getEditBrandParams,
    getAddCampaignParams,
    getEditCampaignParams
} from '../utils/payload-generator'

const styles = makeStyles((theme: any) => {
    // const { colors } = theme['foundations-library'] || {}
    return {
        spinnerContainer: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            height: '100%'
        },
        '@global': {
            '.bottom-widget': {
                padding: '2rem 25px !important'
            }
        },
        smsEnrollmentInstructionContainer: { paddingTop: '1rem', paddingBottom: '1rem' }
    }
})

type LoaderActionType = 'submit' | 'delete'
type LoaderEntityType = EnrollmentType.Brand | EnrollmentType.Campaign | EnrollmentType.SmsNumber

type LoaderState = {
    entity: LoaderEntityType
    action: LoaderActionType
} | null

const SMS_REGISTRATION = {
    section: 'sms-registration',
    articles: {
        brandEnrollment: 'brand-enrollment',
        campaignEnrollment: 'campaign-enrollment',
        smsNumberEnrollment: 'sms-number-enrollment'
    }
} as const

type HowToCategoryType =
    typeof SMS_REGISTRATION.articles[keyof typeof SMS_REGISTRATION.articles]

const tabToCategoryMap = {
    [EnrollmentType.Brand]: SMS_REGISTRATION.articles.brandEnrollment,
    [EnrollmentType.Campaign]: SMS_REGISTRATION.articles.campaignEnrollment,
    [EnrollmentType.SmsNumber]: SMS_REGISTRATION.articles.smsNumberEnrollment
} as const

/**
 *
 */
function SmsEnrollmentTabs (): JSX.Element {
    const classes = styles()
    const [currentTab, setCurrentTab] = useState(0)
    const [showHelp, setShowHelp] = useState(false)

    const [previewBrandFeature, setPreviewBrandFeature] = useState(false)
    const [previewCampaignFeature, setPreviewCampaignFeature] = useState(false)

    const [deleteSmsNumberFeature, setDeleteSmsNumberFeature] = useState(false)
    const [deleteCampaignFeature, setDeleteCampaignFeature] = useState(false)
    const [deleteBrandFeature, setDeleteBrandFeature] = useState(false)

    const [editBrandFeature, setEditBrandFeature] = useState(false)
    const [editCampaignFeature, setEditCampaignFeature] = useState(false)

    const [activePage, setActivePage] = useState(false)
    const [forceShowListPage, setForceShowListPage] = useState(false)
    const [loaderState, setLoaderState] = useState<LoaderState>(null)
    const [forceCreatePage, setForceCreatePage] = useState(false)

    useEffect(() => {
        if (forceCreatePage) setTimeout(() => setForceCreatePage(false), 1000)
    }, [forceCreatePage])
    const { findSectionBySlug, setPageBasedData, pageBasedData, findArticlesBySectionAndCategory } = useWidgetContext()

    useEffect(() => {
        if (forceShowListPage) {
            setTimeout(() => {
                setForceShowListPage(false)
            }, 100)
        }
    }, [forceShowListPage])

    useEffect(() => {
        getFeatureEnabled('ten_dlc_delete_campaign_number_enabled').then(setDeleteSmsNumberFeature)
        getFeatureEnabled('ten_dlc_delete_campaign_enabled').then(setDeleteCampaignFeature)
        getFeatureEnabled('ten_dlc_delete_brand_enabled').then(setDeleteBrandFeature)
        getFeatureEnabled('ten_dlc_preview_brand_enabled').then(setPreviewBrandFeature)
        getFeatureEnabled('ten_dlc_preview_campaign_enabled').then(setPreviewCampaignFeature)
        getFeatureEnabled('ten_dlc_edit_brand_enabled').then(setEditBrandFeature)
        getFeatureEnabled('ten_dlc_edit_campaign_enabled').then(setEditCampaignFeature)
    }, [])

    const {
        networkPending: brandNetworkPending,
        enrollmentEnabled,
        brands,
        fetchBrands,
        deleteBrand,
        addBrand,
        editBrand,
        initialFetchParams: initialBrandFetchParams,
        brandNetworkError,
        setBrandNetworkError
    } = useContext(BrandsContext)
    const {
        networkPending:
        campaignNetworkPending,
        campaigns,
        fetchCampaigns,
        deleteCampaign,
        addCampaign,
        editCampaign,
        initialFetchParams: initialCampaignFetchParams,
        campaignNetworkError,
        setCampaignNetworkError
    } = useContext(CampaignContext)
    const {
        networkPending: smsnumberNetworkPending,
        campaignsWithNumber,
        deleteNumber,
        addNumber,
        numberNetworkError,
        setNumberNetworkError
    } = useContext(SmsNumberCampaignContext)

    useEffect(() => {
        setBrandNetworkError(null)
        setCampaignNetworkError(null)
        setNumberNetworkError(null)
    }, [currentTab])

    const onTabChangeEventHandler = (value) => {
        setCurrentTab(value)
    }

    const getDeleteBrandParams = (brand) => {
        const params = {
            csp_brand_id: brand.csp_brand_id
        }
        return params
    }

    const getDeleteCampaignParams = (campaign) => {
        const params = {
            csp_campaign_id: campaign.csp_campaign_id,
            mock: campaign.is_mock === 'Y',
            onSuccess: () => {
                fetchBrands(initialBrandFetchParams)
            }
        }

        return params
    }

    const getDeleteSmsNumberParams = async (smsNumber) => {
        const phonecom = await getPhoneCom()
        const params = {
            account_id: phonecom.voip_id,
            csp_campaign_id: smsNumber?.csp_campaign_id,
            voip_did_ids: [smsNumber?.voip_did_id],
            delete: true,
            onSuccess: () => {
                fetchCampaigns(initialCampaignFetchParams)
            }
        }

        return params
    }

    const brandEditDisabledHelper = (row) => {
        const isDeleted = row.deleted_at != null
        const disabled = isDeleted || !enrollmentEnabled

        return {
            editDisabled: disabled,
            editTooltip:
                disabled
                    ? !enrollmentEnabled
                        ? getValue('sms_enrollment_feature_disabled_tooltip')
                        : isDeleted
                            ? getValue('sms_enrollment_enrollment_status_deleted_tooltip')
                            : null
                    : null
        }
    }

    const includeBrandEditInMenu = (row) => {
        return row.registration_status !== '' && !['pending-review', 'submitted', 'processing'].includes(row.registration_status)
    }

    const includeCampaignEditInMenu = (row) => {
        return row.status !== '' && !['pending-review', 'submitted', 'processing'].includes(row.status)
    }

    const campaignEditDisabledHelper = (row) => {
        const associatedBrand = brands.find(x => row.csp_brand_id === x.csp_brand_id)
        const isDeleted = row.deleted_at != null
        const invalidBrandStatus = associatedBrand?.registration_status === 'pending-review'
        const disabled = isDeleted || invalidBrandStatus || !enrollmentEnabled

        return {
            editDisabled: disabled,
            editTooltip:
                disabled
                    ? (
                        !enrollmentEnabled
                            ? getValue('sms_enrollment_feature_disabled_tooltip')
                            : isDeleted
                                ? getValue('sms_enrollment_enrollment_status_deleted_tooltip')
                                : invalidBrandStatus
                                    ? getValue('sms_enrollment_enrollment_status_pending_tooltip')
                                    : null)
                    : null
        }
    }

    const getAddSmsNumberParams = async (smsNumber) => {
        const phonecom = await getPhoneCom()
        const params = {
            account_id: phonecom.voip_id,
            csp_campaign_id: smsNumber.campaign_step.selectedCampaign.csp_campaign_id,
            voip_did_ids: smsNumber.number_step.selectedPhoneNumber.map(x => x.voip_did_id),
            delete: false,
            onSuccess: () => {
                fetchCampaigns(initialCampaignFetchParams)
            }
        }
        return params
    }

    const brandTableHeadColumns = [
        getValue('sms_enrollment_brand_id_column_name'),
        getValue('sms_enrollment_brand_column_name'),
        getValue('sms_enrollment_registered_column_name'),
        getValue('sms_enrollment_status_column_name'),
        ''
    ]
    const campaignTableHeadColumns = [
        getValue('sms_enrollment_campaign_id_column'),
        getValue('sms_enrollment_brand_column_name'),
        getValue('sms_enrollment_registered_column_name'),
        getValue('sms_enrollment_status_column_name'),
        ''
    ]
    const smsNumberTableHeadColumns = [
        getValue('sms_enrollment_campaign_id_column'),
        getValue('sms_enrollment_sms_number_column_name'),
        ''
    ]

    const onChangeTab = (eType: EnrollmentType, goToCreatePage = false) => {
        setForceCreatePage(goToCreatePage)
        setCurrentTab(eType)
    }

    const renderCurrentTab = () => {
        switch (currentTab) {
                case EnrollmentType.Brand:
                    return (<Enrollment
                        key='brandEnrollment'
                        enrollmentType={EnrollmentType.Brand}
                        itemType='10dlc_sms_brand_delete'
                        acknowledgedTitle='Delete brand'
                        deleteEnrollmentFeature={deleteBrandFeature}
                        previewEnrollmentFeature={previewBrandFeature}
                        editEnrollmentFeature={editBrandFeature}
                        getDeleteParams={getDeleteBrandParams}
                        deleteEnrollment={deleteBrand}
                        getAddParams={getAddBrandParams}
                        getEditParams={getEditBrandParams}
                        onStartSubmit={() => setLoaderState({ entity: EnrollmentType.Brand, action: 'submit' })}
                        onStartDelete={() => setLoaderState({ entity: EnrollmentType.Brand, action: 'delete' })}
                        networkPending={brandNetworkPending}
                        addEnrollment={addBrand}
                        editEnrollment={editBrand}
                        networkError={brandNetworkError}
                        setNetworkError={setBrandNetworkError}
                        editDisabledHelper={brandEditDisabledHelper}
                        enrollmentEnabled={enrollmentEnabled}
                        enrollmentDisabledTooltip={getValue('sms_enrollment_feature_disabled_tooltip')}
                        includeEditInMenu={includeBrandEditInMenu}
                        enrollments={brands}
                        newEnrollmentRemoteID='sms_enrollment_add_brand_button'
                        tableHeadColumns={brandTableHeadColumns}
                        onActivePage={setActivePage}
                        forceShowListPage={forceShowListPage}
                    />)
                case EnrollmentType.Campaign:
                    return (<Enrollment
                        key='campaignEnrollment'
                        enrollmentType={EnrollmentType.Campaign}
                        itemType='10dlc_campaign_delete'
                        acknowledgedTitle='Delete campaign'
                        deleteEnrollmentFeature={deleteCampaignFeature}
                        previewEnrollmentFeature={previewCampaignFeature}
                        editEnrollmentFeature={editCampaignFeature}
                        getDeleteParams={getDeleteCampaignParams}
                        deleteEnrollment={deleteCampaign}
                        getAddParams={async (wizardData) => {
                            const params = await getAddCampaignParams(wizardData)
                            return {
                                ...params,
                                onSuccess: () => fetchBrands(initialBrandFetchParams)
                            }
                        }}
                        getEditParams={getEditCampaignParams}
                        onStartSubmit={() => setLoaderState({ entity: EnrollmentType.Campaign, action: 'submit' })}
                        onStartDelete={() => setLoaderState({ entity: EnrollmentType.Campaign, action: 'delete' })}
                        networkPending={campaignNetworkPending}
                        addEnrollment={addCampaign}
                        editEnrollment={editCampaign}
                        networkError={campaignNetworkError}
                        setNetworkError={setCampaignNetworkError}
                        editDisabledHelper={campaignEditDisabledHelper}
                        enrollmentEnabled={enrollmentEnabled}
                        enrollmentDisabledTooltip={getValue('sms_enrollment_feature_disabled_tooltip')}
                        includeEditInMenu={includeCampaignEditInMenu}
                        enrollments={campaigns}
                        newEnrollmentRemoteID='sms_enrollment_add_new_campaign'
                        tableHeadColumns={campaignTableHeadColumns}
                        onActivePage={setActivePage}
                        forceShowListPage={forceShowListPage}
                        onChangeTab={onChangeTab}
                        forceShowWizard={forceCreatePage}
                    />)
                case EnrollmentType.SmsNumber:
                    return (<Enrollment
                        key='smsNumberEnrollment'
                        enrollmentType={EnrollmentType.SmsNumber}
                        itemType='10dlc_sms_number_delete'
                        acknowledgedTitle='Delete association'
                        deleteEnrollmentFeature={deleteSmsNumberFeature}
                        getDeleteParams={getDeleteSmsNumberParams}
                        deleteEnrollment={deleteNumber}
                        getAddParams={getAddSmsNumberParams}
                        onStartSubmit={() => setLoaderState({ entity: EnrollmentType.SmsNumber, action: 'submit' })}
                        onStartDelete={() => setLoaderState({ entity: EnrollmentType.SmsNumber, action: 'delete' })}
                        networkPending={smsnumberNetworkPending}
                        addEnrollment={addNumber}
                        networkError={numberNetworkError}
                        setNetworkError={setNumberNetworkError}
                        enrollmentEnabled={enrollmentEnabled}
                        enrollmentDisabledTooltip={getValue('sms_enrollment_feature_disabled_tooltip')}
                        includeEditInMenu={() => false}
                        enrollments={campaignsWithNumber}
                        newEnrollmentRemoteID='sms_enrollment_add_new_number'
                        tableHeadColumns={smsNumberTableHeadColumns}
                        onActivePage={setActivePage}
                        forceShowListPage={forceShowListPage}
                        forceShowWizard={forceCreatePage}
                    />)
        }
    }

    const setHowToBasedData = (slug: HowToCategoryType | null) => {
        const sectionSlug = SMS_REGISTRATION.section
        const locationWithHash = location.pathname + location.hash
        const section = findSectionBySlug(sectionSlug)
        if (section) {
            const articles: WidgetArticleType[] = slug
                ? (findArticlesBySectionAndCategory(sectionSlug, slug) || [])
                : (section.articles || [])

            setPageBasedData({ ...section, articles, selectedArticleCategory: slug }, locationWithHash)
        }
    }

    const getHowToCategory = (): HowToCategoryType | null => {
        if (currentTab === EnrollmentType.Brand && activePage === 'list' && !brands.length) {
            return null
        }

        return tabToCategoryMap[currentTab ?? EnrollmentType.Brand]
    }

    useEffect(() => {
        if (!pageBasedData?.slug) return
        setHowToBasedData(getHowToCategory())
    }, [activePage, brands.length, currentTab, pageBasedData?.slug])

    const screenSize = useContext(ScreenSizeContext)
    const sidebarHidden = screenSize.mobile || screenSize.tablet

    const onClickBack = () => {
        setForceShowListPage(true)
    }

    const getLoaderTitle = () => {
        if (!loaderState) return ''
        if (loaderState.action === 'delete') {
            if (loaderState.entity === EnrollmentType.Brand) return 'Deleting Brand...'
            if (loaderState.entity === EnrollmentType.Campaign) return 'Deleting Campaign...'
            return 'Deleting number...'
        }
        if (loaderState.entity === EnrollmentType.SmsNumber) {
            return 'Processing your request...'
        }
        return 'Processing your payment...'
    }
    const isAnyPending = brandNetworkPending || campaignNetworkPending || smsnumberNetworkPending
    const isActionLoaderOpen = isAnyPending && loaderState != null
    const isInitialPageLoading = isAnyPending && loaderState == null

    return (
        <>
            <Header
                onClickBack={onClickBack}
                activePage={activePage}
                currentTab={currentTab}
                brands={brands}
                campaigns={campaigns}
                campaignsWithNumber={campaignsWithNumber}
            />
            <div className={classes.smsEnrollmentInstructionContainer} data-testid='sms-tabs-container'>
                {isInitialPageLoading
                    ? <LoaderFull styles={{ loaderFull: { left: sidebarHidden ? '50%' : 'calc(50% + 120px)' } }} size='big' data-testid='sms-tabs-loader-full'/>
                    : showHelp
                        ? (
                            <SmsEnrollmentInstruction proceedClicked={() => setShowHelp(false)} />
                        )
                        : (
                            <>
                                <Tabs
                                    className={'tabs'}
                                    value={currentTab}
                                    brands={brands}
                                    campaigns={campaigns}
                                    onChange={onTabChangeEventHandler}
                                    data-testid='sms-tabs-tabs'
                                />
                                <div style={{ marginTop: '40px' }}>
                                    {renderCurrentTab()}
                                </div>
                            </>
                        )}

            </div>
            <LoaderDialog
                isOpen={isActionLoaderOpen}
                title={getLoaderTitle()}
                subtitle='Please wait!'
                data-testid='loader-dialog'
            />
        </>)
}

export default SmsEnrollmentTabs
